// Merchant-excluded products stay blocked at checkout even if an old catalog is cached.
import catalogExclusions from "../../data/catalog-exclusions.json";

export const shippingReviewHandles = new Set(catalogExclusions.handles);
